module.exports = __webpack_public_path__ + "static/media/livestock.d6d4bf4a.png";